import {defineAsyncComponent} from "vue";

/**
 * O editor de fórmula, carregado sob demanda: o CodeMirror vem nesse pedaço, que só quem abre uma
 * fórmula — de calculado ou de regra — baixa; quem só usa as coleções nunca o carrega.
 *
 * Uma definição para os dois que o usam, a base dos formulários de propriedade e o de regras: duas
 * chamadas ao `defineAsyncComponent` seriam dois componentes, e dois carregamentos a acompanhar.
 */
export default defineAsyncComponent(() => import('@/components/design/property/FormulaInput.vue'))
